import moment from "moment";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NTformatDate, dateToSlice, getDeviceTimeZone, getImage, getMomentDate } from "../../utils";
import { getDayAvailability, rescheduleRange } from "../../store/appointment/appointmentActions";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import Calendar from "react-calendar";
import ReactSelect from "react-select";
import Carousel from "react-multi-carousel";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const RescheduleRangeEvent = ({ setIsReschedule, events, refreshParent, currentEvent, setIsDisabling, setIsOpen, isSchedule }) => {

    const dispatch = useDispatch();
    const { currentProfile } = useSelector((state) => state.profile)

    const [availableOptions, setAvailableOptions] = useState([]);
    const [loadingAvailability, setLoadingAvailability] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const carouselRef = useRef(null)
    const { handleSubmit, control, watch, register, setValue, getValues } = useForm({
        defaultValues: {
            reschedule: events,
            applySharedDetails: true,
            sharedReason: null,
            sharedMessage: ""
        }
    })

    const getTakenSlices = () => {
        const currentEvents = getValues("reschedule");

        let k = currentEvents.reduce((filtred, slice) => {
            if(slice.time && slice.time.value)
                filtred.push(slice.time.label);
            return filtred;
        }, [])
        
        return k;
    }
    const getDayAvailabilityAction = (day) => {
        setLoadingAvailability(true);
        setAvailableOptions([]);
        
        dispatch(getDayAvailability({
            profile: currentProfile._id,
            day: NTformatDate(day)
        }))
            .unwrap()
            .then(v => {
                let takenSlices = getTakenSlices()

                if(!isSchedule){
                    let startSelected = moment(currentEvent.startStr).format("YYYY-MM-DDTHH:mm:ssZ");
                    let endSelected = moment(currentEvent.endStr).format("YYYY-MM-DDTHH:mm:ssZ");
                    let slices = v.reduce((filtred, slice) => {
                        let taken = takenSlices.includes(dateToSlice(slice.date));
                        if(!taken && (moment(slice.date).isBefore(startSelected) || moment(slice.date).isSameOrAfter(endSelected)))
                            filtred.push({
                                value: getMomentDate(slice.date),
                                label: dateToSlice(slice.date)
                            });
                        return filtred;
                    }, [])
                    setAvailableOptions(slices)
                }else{
                    let slices = v.reduce((filtred, slice) => {
                        let taken = takenSlices.includes(dateToSlice(slice.date));
                        if(!taken)
                            filtred.push({
                                value: getMomentDate(slice.date),
                                label: dateToSlice(slice.date)
                            });
                        return filtred;
                    }, [])
                    setAvailableOptions(slices)
                }
                
            })
            .catch(() => setAvailableOptions([]))
            .finally(() => setLoadingAvailability(false))
    }



    const handleReschedule = (data) => {
        setIsSubmitting(true);
        const mappedEvents = data.reschedule.map((v) => {
            const mappedReason = data.applySharedDetails ? (data.sharedReason || v.reason) : v.reason;
            const mappedMessage = data.applySharedDetails ? (data.sharedMessage || v.message) : v.message;
            return ({ _id: v._id, time: v.time, message: mappedMessage, reason: mappedReason });
        });
        dispatch(rescheduleRange({
            start: moment(currentEvent.startStr).parseZone().format("YYYY-MM-DDTHH:mm:ssZ"),
            end: moment(currentEvent.endStr).parseZone().format("YYYY-MM-DDTHH:mm:ssZ"),
            action: "reschedule",
            timezone: getDeviceTimeZone(),
            events: mappedEvents
        }))
            .unwrap()
            .then((v) => {
                setIsDisabling(false);
                setIsOpen(false)
                setIsReschedule(false)
                refreshParent();
            })
            .finally(() => setIsSubmitting(false))
        // dispatch(rescheduleSingleAppointment(data))
        //     .unwrap()
        //     .then(v => refreshParent())
    }

    const {
        fields: rescheduleFields
    } = useFieldArray({
        control,
        name: "reschedule",
    });

    const ReasonOptions = [
        { value: 0, label: "The student asked to reschedule" },
        { value: 1, label: "Health issues" },
        { value: 2, label: "I am taking leave" },
        { value: 3, label: "I wish to change my rates" },
        { value: 4, label: "I have another commitment" },
        { value: 5, label: "I have a technical problem" },
        { value: 6, label: "Other" },
    ]

    const responsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 4000, min: 3000 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1
        }
    };

    const Appointment = ({ event }) => {
        return <div className='mb-4 flex items-center gap-2 rounded-xl border border-slate-200 bg-slate-50 p-3'>
            <img className='h-12 w-12 rounded-full object-cover' src={getImage(event.avatar, "AVATAR")} />
            <div className='min-w-0'>
                <h4 className='truncate capitalize text-nt-blue'>{event.title}</h4>
                <span className='text-sm text-nt-grey'>{moment(event.date).parseZone().format("YYYY-MM-DD HH:mm").toString()}</span>
            </div>
        </div>
    }

    const ButtonGroup = ({ next, previous, ...rest }) => {
        const { carouselState: { currentSlide } } = rest;
        return (
            <div className="absolute right-0 top-3 flex gap-2">
                <button type="button" className={`grid h-9 w-9 place-items-center rounded-full border border-slate-200 bg-white ${currentSlide === 0 ? "pointer-events-none opacity-50" : ""} text-nt-blue`} onClick={() => previous()}><FiChevronLeft size={20} /></button>
                <button type="button" className={`grid h-9 w-9 place-items-center rounded-full border border-slate-200 bg-white ${currentSlide === rescheduleFields.length - 1 ? "pointer-events-none opacity-50" : ""} text-nt-blue`} onClick={() => next()}><FiChevronRight size={20} /></button>
            </div>
        );
    };

    const nextSlide = () => {
        if (carouselRef.current) {
          carouselRef.current.next();
        }
    };
    const selectStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: "44px",
            borderColor: state.isFocused ? "#191D51" : "#d9dde5",
            boxShadow: state.isFocused ? "0 0 0 1px #191D51" : "none",
            borderRadius: "12px",
            "&:hover": { borderColor: "#191D51" },
        }),
        menu: (base) => ({
            ...base,
            borderRadius: "12px",
            overflow: "hidden",
        }),
    };

    const applySharedDetails = watch("applySharedDetails");
    const sharedReason = watch("sharedReason");

    return <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
        <form className="flex flex-col gap-5" onSubmit={handleSubmit((data) => handleReschedule(data))}>
            <div className="border-b border-slate-100 pb-3">
                <h3 className="text-nt-blue">Reschedule Courses</h3>
                <p className="mt-1 text-sm text-nt-grey">Pick a new date/time for each affected course and provide a reason.</p>
            </div>

            <div className="rounded-xl border border-slate-200 bg-slate-50 p-3">
                <label className="mb-3 flex items-center gap-2 text-sm font-medium text-slate-700">
                    <input type="checkbox" className="h-4 w-4 accent-[#191D51]" {...register("applySharedDetails")} />
                    Use one reason/message for all courses
                </label>
                {applySharedDetails ? (
                    <div className="space-y-3">
                        <div>
                            <label className="mb-2 block text-xs font-semibold uppercase tracking-wide text-nt-grey">Shared reason</label>
                            <Controller
                                control={control}
                                name="sharedReason"
                                render={({ field: { onChange, value } }) => (
                                    <ReactSelect
                                        maxMenuHeight={200}
                                        className="w-full"
                                        placeholder="Reason for all courses"
                                        onChange={onChange}
                                        value={value || ''}
                                        options={ReasonOptions}
                                        styles={selectStyles}
                                    />
                                )}
                            />
                        </div>
                        <div>
                            <label className="mb-2 block text-xs font-semibold uppercase tracking-wide text-nt-grey">Shared message (optional)</label>
                            <textarea
                                {...register("sharedMessage")}
                                rows={3}
                                className="w-full rounded-xl border border-nt-grey-light p-3 text-sm focus:border-nt-blue focus:ring-1 focus:ring-nt-blue"
                                placeholder="This message will be sent with all rescheduled courses."
                            ></textarea>
                        </div>
                    </div>
                ) : null}
            </div>
            <Carousel
                ref={carouselRef}
                swipeable={false}
                draggable={false}
                showDots={false}
                responsive={responsive}
                ssr={true} // means to render carousel on server-side.
                autoPlay={false}
                arrows={false}
                autoPlaySpeed={1000}
                keyBoardControl={false}
                customTransition="all .5"
                transitionDuration={500}
                containerClass="carousel-container"
                deviceType={"tablet"}
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-40-px"
                customButtonGroup={<ButtonGroup />}
            >
                {
                    rescheduleFields.map((event, index) => {
                        // const dateField = watch(`reschedule.${index}.date`)
                        const timeField = watch(`reschedule.${index}.time`)
                        const reasonField = watch(`reschedule.${index}.reason`)
                        const dateField = watch(`reschedule.${index}.date`)
                        const canGoNext = Boolean(timeField?.value && (applySharedDetails ? true : reasonField?.value));
                        const isLast = rescheduleFields.length === 1 || index + 1 === rescheduleFields.length;
                        return <div className="flex flex-col w-full" key={index}>
                            <div className="mb-3">
                                <span className="rounded-full bg-slate-100 px-2.5 py-1 text-xs font-medium text-slate-600">
                                    Course {index + 1} of {rescheduleFields.length}
                                </span>
                            </div>
                            <Appointment event={event} />
                            <div className="w-full">
                                <label className="mb-2 block text-xs font-semibold uppercase tracking-wide text-nt-grey">Pick new date</label>
                                <Controller
                                    control={control}
                                    name={`reschedule.${index}.date`}
                                    render={({ field: { onChange, value } }) => (
                                        <Calendar className={"nt-calendar nt-calendar--reschedule w-full"}
                                            onChange={(e) => { onChange(e); getDayAvailabilityAction(e); setValue(`reschedule.${index}.time`, null) }}
                                            value={value || null}
                                            view='month'
                                            formatShortWeekday={(locale, date) => moment(date).format("dd")}
                                            minDate={moment().add(1, "day").add(1, "hour").toDate()}
                                            maxDate={moment().add(1, "year").add(1, "hour").toDate()}
                                        />
                                    )}
                                />


                            </div>
                            <div className="w-full mt-5">
                                <label className="mb-2 block text-xs font-semibold uppercase tracking-wide text-nt-grey">Available time</label>
                                <Controller
                                    control={control}
                                    name={`reschedule.${index}.time`}
                                    render={({ field: { onChange, value } }) => (
                                        <ReactSelect
                                            maxMenuHeight={200}
                                            className="w-full"
                                            placeholder="Time"
                                            required={true}
                                            isLoading={loadingAvailability}
                                            isDisabled={!dateField || loadingAvailability}
                                            onChange={onChange}
                                            value={value || ''}
                                            options={availableOptions}
                                            noOptionsMessage={() => (
                                                dateField ? "No available times for this day" : "Pick a date first"
                                            )}
                                            styles={selectStyles}
                                        />
                                    )}
                                />
                                {!loadingAvailability && dateField && availableOptions.length === 0 ? (
                                    <p className="mt-2 text-xs text-nt-grey">No free slots found for this date. Try another day.</p>
                                ) : null}
                                {!applySharedDetails ? (
                                    <>
                                        <label className="mb-2 mt-4 block text-xs font-semibold uppercase tracking-wide text-nt-grey">Reason</label>
                                        <Controller
                                            control={control}
                                            name={`reschedule.${index}.reason`}
                                            render={({ field: { onChange, value } }) => (
                                                <ReactSelect
                                                    maxMenuHeight={200}
                                                    className="w-full"
                                                    placeholder="Reason"
                                                    required={true}
                                                    onChange={onChange}
                                                    value={value || ''}
                                                    options={ReasonOptions}
                                                    styles={selectStyles}
                                                />
                                            )}
                                        />
                                        <label className="mb-2 mt-4 block text-xs font-semibold uppercase tracking-wide text-nt-grey">Message (optional)</label>
                                        <textarea name="message" {...register(`reschedule.${index}.message`)} rows={4} className="w-full rounded-xl border border-nt-grey-light p-3 text-sm focus:border-nt-blue focus:ring-1 focus:ring-nt-blue" placeholder="Add details ..."></textarea>
                                    </>
                                ) : null}
                            </div>
                            {(rescheduleFields.length > 1 && index + 1 < rescheduleFields.length) && (
                                <button
                                    type="button"
                                    disabled={!canGoNext}
                                    className={`mt-4 w-full rounded-xl px-3 py-3 text-white transition ${canGoNext ? "bg-nt-blue hover:opacity-95" : "bg-nt-grey opacity-70 cursor-not-allowed"}`}
                                    onClick={() => nextSlide()}
                                >
                                    Save and continue
                                </button>
                            )}
                            {isLast && (
                                <button
                                    disabled={getTakenSlices().length !== rescheduleFields.length || isSubmitting || (applySharedDetails && !sharedReason)}
                                    className={`mt-4 w-full rounded-xl px-3 py-3 text-white transition ${(getTakenSlices().length === rescheduleFields.length && !isSubmitting && (!applySharedDetails || sharedReason)) ? "bg-nt-blue hover:opacity-95" : "bg-nt-grey opacity-70 cursor-not-allowed"}`}
                                >
                                    {isSubmitting ? "Rescheduling..." : "Confirm reschedule"}
                                </button>
                            )}

                        </div>

                    })
                }

            </Carousel>

            <div className="flex justify-center gap-5 border-t border-slate-100 pt-2">
                {/* {(events.length == 1 || carousel.currentSlide + 1 === events.length) && <button className="w-40 bg-nt-blue text-white px-2 py-3 rounded">Reschedule</button>} */}
                <button type="button" className="w-full rounded-xl bg-slate-200 px-2 py-3 text-slate-700 transition hover:bg-slate-300" onClick={() => setIsReschedule(false)} disabled={isSubmitting}>Cancel</button>
            </div>
        </form>

    </div >
}
export { RescheduleRangeEvent }